export default "__VITE_ASSET__CCnzNDxV__"